import {Structure} from '../structure/structure';
import {SafeUrl} from '@angular/platform-browser';
import {MmModel} from '@docma-mm-core/model/mm.model';
import {MmSyncableModel} from '@docma-mm-core/model/mm-syncable.model';
import {BehaviorSubject} from 'rxjs';
import {User} from '@docma-mm-core/user/user';
import {DocumentType} from '@docma-mm-core/document-type/document-type';
import {AttachmentType} from './attachment-type';
import {ScribbleLayerData} from '@docma-mm-core/scribble/scribble-layers';
import {Scribble} from '@docma-mm-core/scribble/scribble';

export class AttachmentData {

  constructor(init?: Partial<AttachmentData>) {
    if (init) {
     Object.assign(this, init);
     if (init.Date) {
      this.Date = new Date(init.Date);
     }
     if (init.CreatedOn) {
      this.CreatedOn = new Date(init.CreatedOn);
     }
     if (init.ModifiedOn) {
      this.ModifiedOn = new Date(init.ModifiedOn);
     }
    }
  }

  Structure?: Structure;
  Id?: number;
  UniqueId?: string;
  SUid?: string;
  Size?: number;
  MimeType?: string;
  FileName?: string;
  Description?: string;
  Comment?: string;
  Date?: Date;
  Type?: AttachmentType;
  VisibleFor?: number;
  EditableFor?: number;
  IsFaultAttachment?: boolean ;
  IsActivityAttachment?: boolean ;
  DocumentType?: DocumentType;
  Creator?: User;
  Modifier?: User;
  CreatedOn?: Date;
  ModifiedOn?: Date;
  OriginalFileName?: string;
  ScribbleLayers?: ScribbleLayerData[];
}

export class AttachmentSource extends MmModel<File> {
  constructor(init?: Partial<AttachmentSource>) {
    super(init);
    if (init) {
      this.url = init.url;
      this.name = init.name;
    }
  }
  url: string | SafeUrl;
  name: string;
}

export class Attachment extends MmSyncableModel<AttachmentData> {

  private thumbnailSubject = new BehaviorSubject<AttachmentSource>(new AttachmentSource());
  public thumbnail$ = this.thumbnailSubject.asObservable();

  private previewSubject = new BehaviorSubject<AttachmentSource>(new AttachmentSource());
  public preview$ = this.previewSubject.asObservable();

  private sourceSubject = new BehaviorSubject<AttachmentSource>(new AttachmentSource());
  public source$ = this.sourceSubject.asObservable();

  private scribblesSubject = new BehaviorSubject<Array<Scribble>>([]);
  public scribbles$ = this.scribblesSubject.asObservable();

  isPdf?: boolean;
  isOtherType?: boolean;

  fault: {id?: number, uid?: string};
  activity: {id?: number, uid?: string};




  constructor(init?: Partial<Attachment>) {
    super(init);
    if (init) {
      if (init.source) {
        this.source = new AttachmentSource(init.source);
      }
    }
    if (!this.source) {
      this.source = new AttachmentSource();
    }
    if (!this.thumbnail) {
      this.thumbnail = new AttachmentSource();
    }

  }

  get isNew(): boolean {
    return !this.id;
  }

  get thumbnail(): AttachmentSource {
    return this.thumbnailSubject.value;
  }

  set thumbnail(v: AttachmentSource) {
    this.thumbnailSubject.next(v);
  }

  get preview(): AttachmentSource {
    return this.previewSubject.value;
  }

  set preview(v: AttachmentSource) {
    this.previewSubject.next(v);
  }

  get source(): AttachmentSource {
    return this.sourceSubject.value;
  }

  set source(v: AttachmentSource) {
    this.sourceSubject.next(v);
  }

  get scribbles(): Scribble[] {
    return this.scribblesSubject.value;
  }
  set scribbles(v: Scribble[]) {
    this.scribblesSubject.next(v);
  }

  static getDataFromFile(file: File): AttachmentData {
    const ad = new AttachmentData();
    // If PixFile, use timestamp as Date
    if ((file as any).timestamp) {
      ad.Date = new Date((file as any).timestamp);
    } else {
      ad.Date = file.lastModified ? new Date(file.lastModified) : null ;
    }
    ad.MimeType = file.type;
    ad.FileName = file.name;
    ad.Size = file.size;
    return ad;
  }

  addScribbles(scribbles: Scribble[]) {
    const newArray = [...this.scribbles || []];
    for (const scribble of (scribbles ?? [])) {
      if (!this.scribbles.find(sc => sc.uid === scribble.uid)) {
        // scribble.fault = { id: this.id, uid: this.uid };
        newArray.push(scribble);
      }
    }
    this.scribbles = newArray;
  }

  removeScribbles(scribbles: Scribble[]) {
    const newArray = [...this.scribbles || []];
    for (const scribble of (scribbles ?? [])) {
      const foundIndex = newArray.findIndex(sc => sc.uid === scribble.uid);
      if (foundIndex !== -1) {
        newArray.splice(foundIndex, 1);
      }
    }
    this.scribbles = newArray;
  }
}
